import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const AddNewCampaign = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [sourceOptions, setSourceOptions] = useState([]);
  const [publisherdd, setPublisherlist] = useState([]);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

  
    console.log("formData", formData);

    // Show confirmation alert
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to create this Campaign?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          setLoading(true); // Start loading
          const payload = {
            campaign_name: formData.campaign_name,
            publisher_id: formData.publisher_id,
            source_id: formData.source_name,
            campaign_desc: formData.campaign_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
          const response = await axiosInstance.post(
            "/campaign/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Campaign created successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate("/admin/manage-campaign/campaign");
            });
          }
        } catch (error) {
          console.error("Error adding campaign:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      },
    });

    if (!result.isConfirmed) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchPublisherOptions = async () => {
      if (!formData.source_name) return;

      try {
        const payload = {
          source_id: formData.source_name,
          business_partner_id: userType==="superadmin"?formData?.business_partner_id:businessPartnerId,
        };

        const response = await axiosInstance.post(
          "/publisher/ddlpublisher",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const publisherList = response.data.data.data.map((publish) => ({
          label: publish.NAME,
          value: publish.ID,
        }));

        setPublisherlist(publisherList);
      } catch (error) {
        console.error("Error fetching subproduct list:", error);
      }
    };

    fetchPublisherOptions();
  }, [formData.source_name, authToken]);

  useEffect(() => {
    const fetchSourceOptions = async () => {
      try {
        const business_partner_id = userType==="superadmin"?formData?.business_partner_id:businessPartnerId; // Replace with actual business_partner_id
        const response = await axiosInstance.post(
          "/source/list",
          {
            business_partner_id,
            orderBy: "source_id desc",
            page: 0,
            pageSize: 100,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const options = response.data.data.data.map((source) => ({
          label: source.source_name,
          value: source.source_id,
        }));

        setSourceOptions(options);
      } catch (error) {
        console.error("Error fetching source options:", error);
      }
    };

    fetchSourceOptions();
  }, [formData?.business_partner_id]);

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
             
            },
          },
        ]
      : []),
    {
      name: "campaign_name",
      label: "Campaign Name",
      placeholder: "Enter Campaign Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "campaign_desc",
      label: "Campaign Description",
      placeholder: "Enter Campaign Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "source_name",
      label: "Source Name",
      type: "dropdown",
      required: true,
      options: sourceOptions,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "publisher_id",
      label: "Publisher Name",
      type: "dropdown",
      required: true,
      options: publisherdd,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status Name",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const backNavigation = () => {
    navigate("/admin/manage-campaign/campaign");
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={backNavigation}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add New Campaign</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Campaign Details
            </span>
            <DynamicForm
              // formConfig={CustomerInputs.map(input =>
              //   input.name === 'source_name' ? { ...input, options: sourceOptions } : input
              // )}
              formConfig={CustomerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddNewCampaign;
